import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {PlusIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {MakeMerchantUserResourcesAccessLink} from "../../../../../common/MerchantUserResourcesAccessLink";


class AddNewOrLoadCardComponentStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
    };

    @styleRule
    addNewCard = {
        cursor: "pointer",
        fontWeight: this.themeProps.FONT_WEIGHT_REGULAR,
        whiteSpace: "nowrap",
        display: "flex",
    };
}

@registerStyle(AddNewOrLoadCardComponentStyle)
export class AddNewOrLoadCardComponent extends UI.Element {
    isValid() {
        return false;
    }

    async getPaymentMethod() {
        return this.options.card;
    }

    render() {
        const {styleSheet} = this;
        const {onAddCard} = this.options;
        const extraPaymentMethodCount = iFrameUserDataService.getExtraPaymentMethodCount();

        return [
            // TODO @cleanup all instances with PlusIcon maybe need to be standardized
            <LinkButton className={styleSheet.addNewCard} onClick={onAddCard}>
                <PlusIcon size={12.25} />
                <span>{Messages.addNewPaymentMethod}</span>
            </LinkButton>,
            MakeMerchantUserResourcesAccessLink(extraPaymentMethodCount),
        ]
    }
}
